// extracted by mini-css-extract-plugin
export var bodyRow = "_dj-d";
export var cardColumns = "_dj-e";
export var ellipsesOverflow = "_dj-2";
export var flatBottomCorners = "_dj-3";
export var flatTopCorners = "_dj-4";
export var headerActionsDropdown = "_dj-f";
export var headerBottomRow = "_dj-c";
export var headerTopRow = "_dj-b";
export var orderDetailsWrapper = "_dj-0";
export var orderInfoContainer = "_dj-1";
export var productDetails = "_dj-9";
export var productImage = "_dj-5";
export var responsiveTable = "_dj-8";
export var shipmentContainer = "_dj-a";
export var tableBottomLeft = "_dj-6";
export var tableBottomRight = "_dj-7";
export var trackingLink = "_dj-g";